import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=0082f5a0&scoped=true&"
import script from "./ReviewDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082f5a0",
  null
  
)

export default component.exports